import pushEventDataLayer from '../../utils/pushEventDataLayer'

const toallaDataLayer = () =>
  pushEventDataLayer(
    'Interacciones - Inicio del juego',
    'cur-v-shooter',
    'click juego',
    'toalla'
  )

const finishGameDataLayer = () =>
  pushEventDataLayer(
    'Interacciones - Finalizar juego',
    'cur-v-shooter',
    'click juego',
    'finalizar juego'
  )

const bonusTackDataLayer = () =>
  pushEventDataLayer(
    'Interacciones - Bonus track',
    'cur-v-shooter',
    'click juego',
    'gota'
  )

export default { toallaDataLayer, finishGameDataLayer, bonusTackDataLayer }
